'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _dec2, _class; // Lib


// Utils


// Actions


// Components


// Constants


// Styles


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRedux = require('react-redux');

var _userHelper = require('../../../../../../common/users/userHelper');

var _sharingPopupActions = require('../sharingPopupActions');

var _Form = require('../../../../../components/form/Form');

var _Form2 = _interopRequireDefault(_Form);

var _FormButton = require('../../../../../components/form/FormButton');

var _FormButton2 = _interopRequireDefault(_FormButton);

var _FormInput = require('../../../../../components/form/fields/FormInput');

var _FormInput2 = _interopRequireDefault(_FormInput);

var _FieldValidationMessages = require('../../../../../components/form/validation/FieldValidationMessages');

var _FieldValidationMessages2 = _interopRequireDefault(_FieldValidationMessages);

var _milanoteForm = require('../../../../../components/form/milanoteForm');

var _milanoteForm2 = _interopRequireDefault(_milanoteForm);

var _TeamSuggestions = require('../../../../../user/teamSuggestions/TeamSuggestions');

var _TeamSuggestions2 = _interopRequireDefault(_TeamSuggestions);

var _boardSharingFormConstants = require('./boardSharingFormConstants');

require('./BoardSharingInputForm.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Redux connect methods
var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
    return {
        onSubmit: function onSubmit(_ref) {
            var userEmail = _ref.userEmail;
            return dispatch((0, _sharingPopupActions.addSharedUser)({ userEmail: userEmail, elementId: ownProps.currentBoardId }));
        },
        addUserHandler: function addUserHandler(_ref2) {
            var userEmail = _ref2.userEmail;
            return dispatch((0, _sharingPopupActions.addSharedUser)({ userEmail: userEmail, elementId: ownProps.currentBoardId }));
        }
    };
};

var BoardSharingInputForm = (_dec = (0, _reactRedux.connect)(null, mapDispatchToProps), _dec2 = (0, _milanoteForm2.default)({
    form: _boardSharingFormConstants.ADD_SHARED_USER_FORM_NAME,
    fieldsConfig: _boardSharingFormConstants.ADD_SHARED_USER_FORM_FIELDS,
    initialValues: { userEmail: '' }
}), _dec(_class = _dec2(_class = function (_React$Component) {
    _inherits(BoardSharingInputForm, _React$Component);

    function BoardSharingInputForm() {
        _classCallCheck(this, BoardSharingInputForm);

        return _possibleConstructorReturn(this, (BoardSharingInputForm.__proto__ || Object.getPrototypeOf(BoardSharingInputForm)).apply(this, arguments));
    }

    _createClass(BoardSharingInputForm, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.refs.userEmail.focus();
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                submitInterceptor = _props.submitInterceptor,
                sanitisedErrors = _props.sanitisedErrors,
                submitting = _props.submitting,
                showingErrors = _props.showingErrors,
                addUserHandler = _props.addUserHandler,
                sharedUsers = _props.sharedUsers,
                values = _props.values;


            var selectedUserIds = sharedUsers.map(_userHelper.getId);

            return _react2.default.createElement(
                'div',
                { className: 'BoardSharingInputForm' },
                _react2.default.createElement(
                    _Form2.default,
                    { className: (0, _classnames2.default)('form', { submitting: submitting }),
                        onSubmit: submitInterceptor,
                        noValidate: true },
                    _react2.default.createElement(
                        'div',
                        { className: 'form-row' },
                        _react2.default.createElement(
                            'div',
                            { className: 'field-info' },
                            _react2.default.createElement(
                                'label',
                                { className: 'field-label', htmlFor: 'userEmail' },
                                'Invite someone to edit this board'
                            )
                        ),
                        _react2.default.createElement(_FieldValidationMessages2.default, { sanitisedError: sanitisedErrors.userEmail }),
                        _react2.default.createElement(
                            'div',
                            { className: 'field-row' },
                            _react2.default.createElement(
                                'div',
                                { className: 'field' },
                                _react2.default.createElement(_FormInput2.default, _extends({}, this.props, { ref: 'userEmail',
                                    name: _boardSharingFormConstants.ADD_SHARED_USER_FORM_FIELDS.userEmail.name,
                                    type: _boardSharingFormConstants.ADD_SHARED_USER_FORM_FIELDS.userEmail.type,
                                    placeholder: 'e.g. alex.lee@milanote.com',
                                    maxLength: _boardSharingFormConstants.ADD_SHARED_USER_FORM_FIELDS.userEmail.maxLength,
                                    autoComplete: 'off' }))
                            ),
                            _react2.default.createElement(
                                'div',
                                null,
                                _react2.default.createElement(
                                    _FormButton2.default,
                                    { className: 'primary', type: 'submit',
                                        disabled: submitting || showingErrors },
                                    'Share'
                                )
                            )
                        ),
                        _react2.default.createElement(_TeamSuggestions2.default, {
                            addUser: addUserHandler,
                            selectedUserIds: selectedUserIds,
                            filterString: values.userEmail })
                    )
                )
            );
        }
    }]);

    return BoardSharingInputForm;
}(_react2.default.Component)) || _class) || _class);


BoardSharingInputForm.propTypes = {
    fields: _propTypes2.default.object,
    submitInterceptor: _propTypes2.default.func,
    submitFailed: _propTypes2.default.bool,
    showingErrors: _propTypes2.default.bool,
    submitting: _propTypes2.default.bool,
    onChange: _propTypes2.default.func,
    addUserHandler: _propTypes2.default.func,
    sanitisedErrors: _propTypes2.default.object,
    currentBoardId: _propTypes2.default.string.isRequired,
    sharedUsers: _propTypes2.default.object,
    values: _propTypes2.default.object
};

exports.default = BoardSharingInputForm;


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/header/utils/sharing/form/BoardSharingInputForm.js
// module id = 2192
// module chunks = 0